// src/pages/NovoUsuarioPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../config/firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp, collection } from "firebase/firestore";
import { NIVEIS } from "../config/niveis";

function traduzErroCriacao(code) {
  switch (code) {
    case "auth/email-already-in-use":
      return "Este e-mail já está em uso.";
    case "auth/invalid-email":
      return "E-mail inválido.";
    case "auth/weak-password":
      return "Senha muito fraca (mínimo 6 caracteres).";
    default:
      return "Erro ao criar usuário. Tente novamente.";
  }
}

function NovoUsuarioPage() {
  const navigate = useNavigate();

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  // Modo FIT: sempre uma empresa, grupo recebe o nome da empresa
  const tipoEstrutura = "UNICA";
  const [empresaNome, setEmpresaNome] = useState("");

  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setErro("");

    if (!nome.trim() || !email.trim() || !senha.trim()) {
      setErro("Preencha nome, e-mail e senha.");
      return;
    }

    if (senha !== confirmarSenha) {
      setErro("As senhas não conferem.");
      return;
    }

    if (!empresaNome.trim()) {
      setErro("Informe o nome da empresa.");
      return;
    }

    setCarregando(true);

    try {
      // 1) Define o grupo da conta:
      //    - Sempre gera um ID real do Firestore para ser o grupoId
      //    - Se for "Empresa Única", o nome do grupo será o nome da empresa base
      const empresaBase = empresaNome.trim();

      const gruposRef = collection(db, "grupos");
      const grupoDocRef = doc(gruposRef); // gera um ID aleatório (real) para o grupo
      const grupoId = grupoDocRef.id;

      const grupoNomeFinal = empresaBase;

      // 2) Cria usuário no Firebase Auth
      //    Obs: ao criar, o Firebase já autentica este usuário.
      const cred = await createUserWithEmailAndPassword(auth, email, senha);

      // 3) ✅ CRIAR O GRUPO ANTES DO DOCUMENTO /usuarios/{uid}
      //    Motivo: pelas regras atuais, /grupos/{gid} só permite CREATE
      //    quando o documento do usuário ainda NÃO existe.
      await setDoc(grupoDocRef, {
        grupoId,
        nome: grupoNomeFinal,
        tipoEstrutura, // "UNICA"
        criadoPor: cred.user.uid,
        criadoEm: serverTimestamp(),
      });

      // 4) Sempre NOVA CONTA → esse cara é Gestor US0001
      const codigoSequencial = 1;
      const codigo = "US0001";

      // 5) Cria o documento do usuário no Firestore
      await setDoc(doc(db, "usuarios", cred.user.uid), {
        nome: nome.trim(),
        email: email.trim(),
        telefone: telefone.trim() || null,

        nivel: NIVEIS.GESTOR,
        primeiroUsuario: true,

        codigoSequencial,
        codigo,

        grupoId, // grupo empresarial da conta (ID real)
        grupoNome: grupoNomeFinal, // nome amigável do grupo
        empresa: empresaBase, // primeira empresa
        tipoEstrutura, // "UNICA"

        globalAccess: true,
        tipoAcesso: "GLOBAL",
        empresasPermitidas: [],

        criadoEm: serverTimestamp(),
      });

      // 5) Cria contador de usuários PARA ESTE GRUPO
      //    Próximos usuários internos deste grupo começam em US0002
      await setDoc(
        doc(db, "contadores", `usuarios_${grupoId}`),
        {
          // 🔒 Regras exigem grupoId também em contadores
          grupoId,
          ultimoCodigoSequencial: codigoSequencial,
          atualizadoEm: serverTimestamp(),
        },
        { merge: true }
      );

      // 6) Cria a primeira empresa vinculada ao grupo (código EM0001)
      const empresasRef = collection(db, "empresas");
      const primeiraEmpresaRef = doc(empresasRef);

      const codigoEmpresaSequencial = 1;
      const codigoEmpresa = "EM0001";

      await setDoc(primeiraEmpresaRef, {
        nome: empresaBase,
        cnpj: null,
        endereco: null,

        grupoId,
        grupoNome: grupoNomeFinal,

        codigoSequencial: codigoEmpresaSequencial,
        codigo: codigoEmpresa,

        criadoPor: cred.user.uid,
        criadoEm: serverTimestamp(),
      });

      // 7) Cria contador de empresas PARA ESTE GRUPO
      await setDoc(
        doc(db, "contadores", `empresas_${grupoId}`),
        {
          // 🔒 Regras exigem grupoId também em contadores
          grupoId,
          ultimoCodigoSequencial: codigoEmpresaSequencial,
          atualizadoEm: serverTimestamp(),
        },
        { merge: true }
      );

      alert(
        `Conta criada com sucesso.\nUsuário Gestor: ${nome}\nCódigo: ${codigo}`
      );

      navigate("/login");
    } catch (err) {
      console.error(err);
      setErro(traduzErroCriacao(err.code));
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020617",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 16,
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: "100%",
          maxWidth: 480,
          background: "#020617",
          border: "1px solid #1f2937",
          borderRadius: 12,
          padding: 24,
          color: "#e5e7eb",
          boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
        }}
      >
        <h1 style={{ fontSize: 22, marginBottom: 8 }}>
          Criar conta / usuário Gestor
        </h1>
        <p style={{ fontSize: 14, marginBottom: 16, color: "#9ca3af" }}>
          Este será o primeiro usuário da conta, com nível{" "}
          <strong>Gestor</strong> e código <strong>US0001</strong>.
        </p>

        {erro && (
          <div
            style={{
              background: "#7f1d1d",
              color: "#fecaca",
              padding: 8,
              borderRadius: 8,
              marginBottom: 12,
              fontSize: 14,
            }}
          >
            {erro}
          </div>
        )}

        {/* Dados pessoais */}
        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>
          Nome
        </label>
        <input
          type="text"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 12,
            borderRadius: 8,
            border: "1px solid #4b5563",
            color: "#e5e7eb",
          }}
        />

        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>
          E-mail
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 12,
            borderRadius: 8,
            border: "1px solid #4b5563",
            color: "#e5e7eb",
          }}
        />

        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>
          Telefone (opcional)
        </label>
        <input
          type="text"
          value={telefone}
          onChange={(e) => setTelefone(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 16,
            borderRadius: 8,
            border: "1px solid #4b5563",
            color: "#e5e7eb",
          }}
          placeholder="(xx) xxxxx-xxxx"
        />

        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>
          Nome da empresa
        </label>
        <input
          type="text"
          value={empresaNome}
          onChange={(e) => setEmpresaNome(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 16,
            borderRadius: 8,
            border: "1px solid #4b5563",
            color: "#e5e7eb",
          }}
          placeholder="Ex: Oficina do André"
        />

        {/* Senha */}
        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>
          Senha
        </label>
        <input
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 12,
            borderRadius: 8,
            border: "1px solid #4b5563",
            color: "#e5e7eb",
          }}
        />

        <label style={{ fontSize: 14, marginBottom: 4, display: "block" }}>
          Confirmar senha
        </label>
        <input
          type="password"
          value={confirmarSenha}
          onChange={(e) => setConfirmarSenha(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            marginBottom: 16,
            borderRadius: 8,
            border: "1px solid #4b5563",
            color: "#e5e7eb",
          }}
        />

        <button
          type="submit"
          disabled={carregando}
          style={{
            width: "100%",
            padding: 10,
            borderRadius: 10,
            border: "none",
            background: carregando ? "#334155" : "#2563eb",
            color: "#fff",
            fontWeight: 700,
            cursor: carregando ? "not-allowed" : "pointer",
          }}
        >
          {carregando ? "Criando..." : "Criar conta"}
        </button>

        <div style={{ marginTop: 14, fontSize: 14, color: "#94a3b8" }}>
          Já tem conta?{" "}
          <span
            onClick={() => navigate("/login")}
            style={{ color: "#60a5fa", cursor: "pointer" }}
          >
            Fazer login
          </span>
        </div>
      </form>
    </div>
  );
}

export default NovoUsuarioPage;
